import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { ClUserInfoComponent } from './user-info.component';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
    declarations: [
        ClUserInfoComponent
    ],
    entryComponents: [
        ClUserInfoComponent
    ],
    exports: [
        ClUserInfoComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
        FlexModule,
        MatInputModule,
        MatTabsModule,
    ],
})
export class UserInfoModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            ClUserInfoComponent
        ]);
    }
}
